import { updatePaymentSystem } from '../api/updatePaymentSystem';
import { setGetListPaymentSystem } from './setGetListPaymentSystem';

const setUpdatePaymentSystem = (params, callbackSuccess ) => {
    return async (dispatch, getState) => {
        try {
            await updatePaymentSystem(params);
            if (callbackSuccess) {
                callbackSuccess()
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setUpdatePaymentSystem
}